import Icon from '@/components/ui/AppIcon';

interface TimelineEvent {
  id: string;
  status: string;
  location: string;
  countryCode: string;
  timestamp: string;
  description: string;
  completed: boolean;
}

interface TrackingTimelineProps {
  events: TimelineEvent[];
}

export default function TrackingTimeline({ events }: TrackingTimelineProps) {
  return (
    <div className="space-y-4">
      {events.map((event, index) => (
        <div key={event.id} className="relative">
          {/* Connector Line */}
          {index < events.length - 1 && (
            <div className={`absolute left-6 top-12 w-0.5 h-full ${event.completed ? 'bg-success' : 'bg-border'}`}></div>
          )}

          <div className="flex gap-4">
            {/* Icon */}
            <div className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center border-2 ${
              event.completed 
                ? 'bg-success border-success text-success-foreground' 
                : 'bg-background border-border text-muted-foreground'
            }`}>
              <Icon 
                name={event.completed ? 'CheckIcon' : 'ClockIcon'} 
                size={24} 
              />
            </div>

            {/* Content */}
            <div className="flex-1 pb-8">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className={`font-semibold ${event.completed ? 'text-foreground' : 'text-muted-foreground'}`}>
                    {event.status}
                  </h3>
                  <p className="text-sm text-muted-foreground">{event.location}</p>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    event.completed 
                      ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                  }`}>
                    {event.countryCode}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground mb-2">{event.description}</p>
              <p className="text-xs text-muted-foreground">{event.timestamp}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}